import { CrudOp, targetAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { IdManagerView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator) => {
  const authHelper = authHelperCreator(targetAuthScope);
  return authHelper.evaluate(CrudOp.READ);
};

export const idManagerViewKey = "project_modular_id-manager/:projectId/:tmmId";
export const idManagerViewModule: ViewModule = {
  viewKey: idManagerViewKey,
  viewEl: <IdManagerView/>,
  displayNameI18nKey: "id-manager:viewName",
  menuIconEl: <span style={{ fontSize: "18px", paddingBottom: "2px" }}>ID</span>,
  isAuthorized,
  translations,
};
